import React from "react";
import { FaArrowRight } from "react-icons/fa";
import HeaderAny from "../../components/header";
import MobileNav from "../../components/header-mobile";
import Footer from "../../components/footer";
import buildingImg from "../../assets/ngo-hero-solar.jpg";
import "./solutions.css";
import "./ngo.css";

const FUNDER_FEATURES = [
    {
        title: "Progress you can see without travelling",
        desc: "Each milestone is recorded on site with photos that carry their time and place of origin, so you can follow projects across counties or countries from one place.",
    },
    {
        title: "Evidence for the donor report",
        desc: "Pull confirmed milestones, dates and photos straight into your reporting. No chasing implementing partners for updates at the deadline.",
    },
    {
        title: "Confirmation from the people who did the work",
        desc: "The contractor and the project owner each confirm every milestone, and registered professionals are linked to the work they signed off.",
    },
    {
        title: "A record that outlasts the grant",
        desc: "Each project keeps its full history, useful for audits, handover to the community or a local authority, and the next funding round.",
    },
];

const REPORT_ITEMS = [
    "Project and milestone timeline",
    "Evidence and confirmations for each milestone",
    "Contractors and professionals on the project",
    "Materials logged against plan",
    "Portfolio view across all funded projects",
];

const PILOT_STEPS = [
    {
        title: "Choose a project",
        desc: "Select an active or planned build, ideally one with an implementing partner already on site.",
    },
    {
        title: "The site team captures milestones",
        desc: "Contractors record progress and confirm it. Conra sets them up and supports them.",
    },
    {
        title: "Review the report",
        desc: "Look at the evidence and audit trail, then decide whether to extend it to more projects.",
    },
];

const NgoPage = () => (
    <div>
        <div className="web-only"><HeaderAny /></div>
        <div className="mobile-only"><MobileNav /></div>

        {/* ── Hero ── */}
        <section className="ngo-hero">
            <div className="ngo-hero-inner">
                <div className="ngo-hero-text">
                    <span className="bnk-hero-who">For NGOs and funders</span>
                    <h1 className="ngo-hero-h1">Show donors the project was delivered, with evidence attached.</h1>
                    <p className="ngo-hero-sub">
                        Conra gives you a confirmed, time-stamped record of construction progress for every school, clinic or housing project you fund, so your donor reports rest on evidence, not summaries.
                    </p>
                    <div className="ngo-hero-actions">
                        <a
                            className="filled-button"
                            href="https://web.conra.net"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Talk to us about a pilot <FaArrowRight style={{ marginLeft: 6 }} />
                        </a>
                        <button
                            className="outlined-button"
                            onClick={() => document.getElementById("report")?.scrollIntoView({ behavior: "smooth" })}
                        >
                            See what a report covers
                        </button>
                    </div>
                </div>
                <div className="ngo-hero-visual">
                    <div className="ngo-hero-img-wrap">
                        <img src={buildingImg} alt="Verified field project" className="ngo-hero-img" />
                        <span className="ngo-hero-badge">
                            <span className="ngo-hero-badge-dot" />
                            Verified &middot; KN21G
                        </span>
                    </div>
                </div>
            </div>
        </section>

        {/* ── What funders get ── */}
        <section className="bnk-features-section">
            <div className="bnk-features-inner">
                <h2 className="bnk-sec-h2">What funders get</h2>
                <p className="bnk-sec-sub">Every claim in a Conra record traces back to something captured on site and confirmed by the people responsible for the work.</p>
                <ul className="bnk-feat-list">
                    {FUNDER_FEATURES.map(({ title, desc }) => (
                        <li key={title}>
                            <strong>{title}</strong>
                            <span>{desc}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </section>

        {/* ── Reports built from the record ── */}
        <section className="bnk-report-section" id="report">
            <div className="bnk-report-inner">
                <div>
                    <h2 className="bnk-sec-h2">Reports built from the record</h2>
                    <p className="bnk-report-body">
                        Choose the project, the milestones and the sections you need. The report is generated from the verified record, not written by AI, so the same inputs give the same report every time.
                    </p>
                </div>
                <ul className="bnk-report-list">
                    {REPORT_ITEMS.map((item) => (
                        <li key={item}>{item}</li>
                    ))}
                </ul>
            </div>
        </section>

        {/* ── Start with one project ── */}
        <section className="bnk-pilot-section">
            <div className="bnk-pilot-inner">
                <h2 className="bnk-sec-h2">Start with one project</h2>
                <p className="bnk-sec-sub">A pilot doesn't need you to change how you fund or manage. Pick one project and see what the record looks like.</p>
                <ol className="bnk-pilot-steps">
                    {PILOT_STEPS.map(({ title, desc }) => (
                        <li key={title}>
                            <h3>{title}</h3>
                            <p>{desc}</p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>

        {/* ── Not banner ── */}
        {/* <section className="pub-not-banner">
            <div className="pub-not-banner-inner">
                <p className="pub-not-banner-text">
                    Conra doesn't manage your project or hold your funds. It verifies what happened.
                </p>
            </div>
        </section> */}

        {/* ── Contact CTA ── */}
        <section className="pub-contact">
            <div className="pub-contact-inner">
                <h2 className="pub-contact-heading">Tell us about what you fund.</h2>
                <p className="pub-contact-sub">
                    We'll show you what a verified record and a donor report would look like for one of your projects.
                </p>
                <a
                    className="filled-button"
                    href="https://web.conra.net"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Get Started
                </a>
            </div>
        </section>

        <Footer />
    </div>
);

export default NgoPage;
